import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
import '../styles/confirm-d10s-modal.css';

/**
 * Modal per la doppia conferma operazioni in valuta (UI: DIOS).
 * Grafica allineata ai modal dell'app (Sale/Loan in Profile, Marketplace).
 * Step 1: messaggio iniziale (es. "Stai per spendere X DIOS per: ...")
 * Step 2: "Conferma di nuovo per procedere."
 */
const ConfirmD10SModal = ({ open, step, firstMessage, secondMessage, onConfirm, onCancel }) => {
  const { t } = useLanguage();

  useEffect(() => {
    if (!open) return undefined;
    document.body.classList.add('confirm-d10s-modal-open');
    return () => {
      document.body.classList.remove('confirm-d10s-modal-open');
    };
  }, [open]);

  if (!open) return null;

  const isStep2 = step === 2;
  const message = isStep2 ? secondMessage : firstMessage;

  return (
    <div
      className="confirm-d10s-overlay fixed inset-0 flex items-center justify-center z-[10050] p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="confirm-d10s-title"
    >
      <div
        className="confirm-d10s-card football-card glass-football p-6 max-w-md w-full"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between mb-4">
          <h2 id="confirm-d10s-title" className="text-2xl font-bold">
            {isStep2 ? t('confirmD10S.titleSecond') : t('confirmD10S.titleFirst')}
          </h2>
          <button
            type="button"
            className="confirm-d10s-close p-2 rounded-lg border-2 transition-colors"
            onClick={onCancel}
            aria-label={t('common.cancel')}
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <p className="confirm-d10s-message mb-6 leading-relaxed text-base">{message}</p>

        <div className="flex space-x-4">
          <button
            type="button"
            className="confirm-d10s-btn-primary btn-football flex-1 py-3 rounded-lg transition-all"
            onClick={onConfirm}
          >
            {isStep2 ? t('confirmD10S.confirmFinal') : t('confirmD10S.confirmContinue')}
          </button>
          <button
            type="button"
            className="confirm-d10s-btn-cancel px-6 py-3 border-2 font-semibold rounded-lg transition-all flex-1"
            onClick={onCancel}
          >
            {t('common.cancel')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmD10SModal;
